import React, { useState, useRef } from 'react'
import { useField, useFormikContext } from 'formik'

import { set } from 'date-fns'

import { XStack, YStack } from 'tamagui'

import { Text } from '@newComponents/Text'
import { FormField } from '@newComponents/Form/FormField'
import { FormCalendarDatePicker } from '@newComponents/Form/FormCalendarDatePicker'
import {
  FormTimePicker,
  FormTimePickerRef,
} from '@newComponents/Form/FormTimePicker'

export const EventFormDatePicker = () => {
  const formContext = useFormikContext()
  const [startField, _startFieldMeta, startFieldHelpers] = useField('startAt')
  const [endField, _endFieldMeta, endFieldHelpers] = useField('endAt')

  const [selectingDate, setSelectingDate] = useState<'start' | 'end'>('start')

  const startAtRef = useRef<FormTimePickerRef>(null)
  const endAtRef = useRef<FormTimePickerRef>(null)

  const values = formContext.values as {
    startAt: Date
    endAt: Date
  }

  const selectDate = (startOrEnd: 'start' | 'end', focus = true) => {
    if (selectingDate !== startOrEnd) {
      setSelectingDate(startOrEnd)

      if (focus) {
        if (startOrEnd === 'start') {
          if (startAtRef.current) {
            startAtRef.current.focus()
          }
        } else {
          if (endAtRef.current) {
            endAtRef.current.focus()
          }
        }
      }
    }
  }

  return (
    <>
      <YStack gap='$2'>
        <FormField name='eventDates' label='Dates' showError={false}>
          <FormCalendarDatePicker
            selectingDate={selectingDate}
            onChangeStartDate={(newStartDate) => {
              if (newStartDate > endField.value) {
                void endFieldHelpers.setValue(
                  set(newStartDate, {
                    hours: values.endAt.getHours(),
                    minutes: values.endAt.getMinutes(),
                  })
                )
              }

              selectDate('end')
            }}
            onChangeEndDate={(newEndDate) => {
              if (newEndDate && newEndDate < startField.value) {
                void startFieldHelpers.setValue(
                  set(newEndDate, {
                    hours: values.startAt.getHours(),
                    minutes: values.startAt.getMinutes(),
                  })
                )
              }

              selectDate('start')
            }}
          />
        </FormField>

        <XStack gap='$2' alignItems='flex-end'>
          <FormField name='startAt' label='Start time' flex={0}>
            <FormTimePicker
              ref={startAtRef}
              isActive={selectingDate === 'start'}
              onFocus={() => selectDate('start')}
            />
          </FormField>

          <YStack height={32} justifyContent='center'>
            <Text size='$6'>&#8594;</Text>
          </YStack>

          <FormField name='endAt' label='End time' flex={0}>
            <FormTimePicker
              ref={endAtRef}
              isActive={selectingDate === 'end'}
              onFocus={() => selectDate('end')}
            />
          </FormField>
        </XStack>
      </YStack>
    </>
  )
}
